import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Bannerone from '../images/bannerone.jpg';
import Bannertwo from '../images/bannertwo.jpg';
import Bannerthree from '../images/bannerthree.jpg';
import Bannerfour from '../images/bannerfour.jpg';

function HeaderCarousel() {
    return (
        <Carousel>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={Bannerone}
                    alt="Personalised hampers for baby shower gift"
                />
                <Carousel.Caption>
                    <h3>Personalised hampers for baby shower gift</h3>
                    <p>This is a Wooden Baby Hamper crate that comes with a clothing rail which you could hang clothes from. To complete the look it is decorated with flowers or pampas grass and LED lights to give that WOW factor..</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={Bannertwo}
                    alt="Treat bags for halloween"
                />

                <Carousel.Caption>
                    <h3>Treat bags for halloween</h3>
                    <p>A spooky gift for little ones to collect sweets on Haloween season.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={Bannerthree}
                    alt="Third slide"
                />

                <Carousel.Caption>
                    <h3>Custom Acrylic Round Cake Topper Hand Painted</h3>
                    <p>
                        The option to have a clear background, painted background and painted background with gold leaf
                    </p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={Bannerfour}
                    alt="Third slide"
                />

                <Carousel.Caption>
                    <h3>A2 Acrylic Wedding Welcome Sign</h3>
                    <p>Available in A2 and many different options available to ensure it ties in perfect with your colour scheme. You can order the Acrylic in frosted or clear and choose a painted background option too.</p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    );
}

export default HeaderCarousel;